import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type { Certificate } from 'bundles/accomplishments/types';
import { CertificateType } from 'bundles/accomplishments/types';

const RESOURCE_NAME = 'certificate.v1';

export const byVerifyCode = (verifyCode: string): Q.Promise<Certificate | undefined> => {
  const api = API(`/api/${RESOURCE_NAME}/`, { type: 'rest' });
  const fields = ['id', 'verifyCode', 'grantedAt', 'certificateType', 'platformOrigin'];

  const uri = new URI()
    .addQueryParam('q', 'byVerifyCode')
    .addQueryParam('verifyCode', verifyCode)
    .addQueryParam('fields', fields.join(','));

  return Q(
    api.get(uri.toString(), {
      data: {},
    })
  ).then((data) => {
    // There is only ever one certificate returned per verifyCode so
    // we can take the head of the list
    const certificateResponse = data.elements && data.elements.length > 0 ? data.elements[0] : undefined;

    if (certificateResponse) {
      const userId = certificateResponse.id.split('~')[0];
      let certificateItemId;
      // id has the form userId~certItemId.
      // Eg. 47246229~Course!~BK2bam0iEeW9CAqYJHF3zQ
      // certItemId has the form
      // Course!~BK2bam0iEeW9CAqYJHF3zQ
      // or
      // Specialization!~-8--wp23EeWX1grj0DVfGw
      // or
      // Specialization!~child!!!~hHjdFjakEeibqxLjao-JFA
      // Proper format for child spec ids is child~hHjdFjakEeibqxLjao-JFA
      if (certificateResponse.certificateType === CertificateType.Course) {
        certificateItemId = certificateResponse.id.split('Course!~')[1];
      } else if (certificateResponse.id.includes('child')) {
        certificateItemId = 'child~' + certificateResponse.id.split('child!!!~')[1];
      } else {
        certificateItemId = certificateResponse.id.split('Specialization!~')[1];
      }

      return {
        userId,
        certificateItemId,
        platformOrigin: certificateResponse.platformOrigin,
        verifyCode: certificateResponse.verifyCode,
        grantedAt: certificateResponse.grantedAt,
        certificateType: certificateResponse.certificateType,
      };
    } else {
      return undefined;
    }
  });
};
